module.exports = __webpack_public_path__ + "img/huanbao3.f7bb0fed.png";